<template>
  <v-navigation-drawer
      :mini-variant="mini"
      permanent
      app
      overflow
  >
    <v-list-item two-line :class="mini && 'px-2'">
      <v-list-item-avatar>
        <img :src="image" alt="Imagem do perfil">
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="title">{{ user.name }}</v-list-item-title>
        <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list
        dense
        nav
    >
      <v-list-item-group v-model="menuSelected" color="info">
        <div v-for="menu in menus" :key="menu.name">
          <v-list-item
              v-if="!menu.childs || menu.childs === []"
              link
              v-on:click="goToRoute(menu.path)"
          >
            <v-list-item-icon>
              <v-badge
                  :content="notifications[menu.name]"
                  :value="notifications[menu.name]"
                  color="error"
                  overlap
              >
                <v-icon>{{ menu.meta.icon }}</v-icon>
              </v-badge>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ menu.meta.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
              v-else
              :value="groupSelected === menu.group"
          >
            <template v-slot:prependIcon>
              <v-badge
                  :content="notifications[menu.name]"
                  :value="notifications[menu.name]"
                  color="error"
                  overlap
              >
                <v-icon>{{ menu.meta.icon }}</v-icon>
              </v-badge>
            </template>

            <template v-slot:activator>
              <v-list-item-title>{{ menu.meta.title }}</v-list-item-title>
            </template>

            <v-list-item-group v-model="subMenuSelected" color="info">
              <v-list-item
                  :class="!mini ? 'pl-8' : ''"
                  v-for="subMenu in menu.childs" :key="subMenu.name"
                  link
                  v-on:click="goToRoute(subMenu.path)"
              >
                <v-list-item-icon>
                  <v-badge
                      :content="notifications[subMenu.name]"
                      :value="notifications[subMenu.name]"
                      color="error"
                      overlap
                  >
                    <v-icon>{{ subMenu.meta.icon }}</v-icon>
                  </v-badge>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ subMenu.meta.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list-group>
        </div>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import routes from '@/router/routes'
import imageDefault from '@/assets/no-avatar.png'
import {mapState} from "vuex"
import {get} from 'lodash'
import hasPermission from '@/helpers/hasPermission'

export default {
  name: "Sidebar",
  computed: {
    ...mapState({
      mini: state => state.layout.mini,
      user: state => state.auth.user,
      permissions: state => state.auth.permissions,
      notifications: state => state.layout.sidebarNotifications
    }),
    currentRouteName: function() {
      return this.$route.name
    },
    menus: function () {
      const routesFiltered = routes
        .filter(route => route.meta.root)
        .filter(route => route.groupHead || !route.group)
        .filter(route => hasPermission(route.meta.permissions))

      return routesFiltered.map(route => {
        let childs = route.groupHead
            ? routes.filter(r => r.group === route.group && !r.groupHead).filter(r => hasPermission(r.meta.permissions))
            : null
        return {
          ...route,
          childs,
        }
      })
    }
  },
  methods: {
    updateData: function({ path, name }) {
      const routeData = path ? routes.find(r => r.path === path) : routes.find(r => r.name === name)
      const routeGroupHead = routeData.group ? routes.find(r => r.group === routeData.group && r.groupHead) : null
      const childs = routeGroupHead ? routes.filter(r => r.group === routeGroupHead.group && !r.groupHead) : null
      const menuSelectedIndex = this.menus.findIndex(r => r.name === this.currentRouteName || this.currentRouteName.includes(r.name))

      this.menuSelected = menuSelectedIndex
      this.groupSelected = routeData.group || null
      this.subMenuSelected = menuSelectedIndex < 0 && routeGroupHead && Array.isArray(childs)
          ? childs.findIndex(r => r.name === this.currentRouteName || this.currentRouteName.includes(r.name))
          : null

      this.updateNotifications({ name: routeData.name, childs, headName: routeGroupHead ? routeGroupHead.name : null })
    },
    updateNotifications: function({ name, childs, headName }) {
      if (!this.notifications[name]) return

      this.notificationsCounters[name] = 0

      if (childs && Array.isArray(childs) && headName) {
        let anyChildHasNotifications = false
        for (const c in childs) {
          const qnt = this.notifications[childs[c].name]
          if (qnt > 0 && childs[c].name !== name) {
            anyChildHasNotifications = true
            break
          }
        }

        if (!anyChildHasNotifications) {
          this.notificationsCounters[headName] = 0
        }
      }

      this.$store.dispatch('layout/updateSidebarNotifications', this.notificationsCounters)
    },
    goToRoute: function (route) {
      if (route === this.$router.currentRoute.path) return
      this.$router.push(route).catch((e) => console.error(e))
      this.updateData({ path: route })
    },
  },
  data: () => ({
    notificationsCounters: {},
    groupSelected: null,
    menuSelected: null,
    subMenuSelected: {},
    image: imageDefault
  }),
  created() {
    this.image = get(this.user, 'image_path', imageDefault)
    this.updateData({ name: this.currentRouteName })
    this.$store.dispatch('layout/getSidebarNotifications')
  },
  watch: {
    user(user) {
      this.image = user.image_path || imageDefault
    },
    notifications(notifications) {
      this.notificationsCounters = JSON.parse(JSON.stringify(notifications))
    }
  }
}
</script>

<style scoped>

</style>
